module.exports = __webpack_public_path__ + "img/product_mb_cn_kr.8746fd5.svg";